import React, { Component } from 'react';
import { clickSearchFacet } from '../../actions/productActions';
import classnames from 'classnames';

class Facet extends Component {
	constructor(props) {
		super(props);
		const facet = props.facet;
		this.state = {
			checked: facet.checked
		};
	}

	handleClick(event) {
		const facet = this.props.groupValue;
		const value = event.target.value;
		const checked = !this.props.facet.checked;

		if (checked === true) {
			this.setState({ checked: true });
		} else {
			this.setState({ checked: false });
		}

		global.dataLayer.push({
			event: 'Find Your Safe',
			eventCategory: 'Find Your Safe',
			eventAction: facet,
			eventLabel: value
		});

		clickSearchFacet(facet, value, checked);
	}
	
	render() {
		const { facet } = this.props;
		const facetId = `facet-${facet.name.replace(/(?!\w|\s)./g, '').replace(/\s+/g, '')}`;
		let facetIcon;
		let iconDouble;
		let iconTriple;
		let hasIcon = false;

		if (facet.security) {
			hasIcon = true;
			facetIcon = (
				<img
					className="facet-icon"
					src={ require('../../resources/img/icons/facet-security-icon.png') }
					srcSet={ `${require('../../resources/img/icons/facet-security-icon.png')} 2x` }
					alt="Security Icon"
				/> 
			);
		}

		if (facet.fire) {
			iconDouble = true;
			facetIcon = (
				<img
					className="facet-double-icon"
					src={ require('../../resources/img/icons/facet-fire-security-icon.png') }
					srcSet={ `${require('../../resources/img/icons/facet-fire-security-icon.png')} 2x` }
					alt="Fire Icon"
				/> 
			);
		}

		if (facet.fireWater) {
			iconTriple = true;
			facetIcon = (
				<img
					className="facet-double-icon"
					src={ require('../../resources/img/icons/facet-all-protections-icon.png') }
					srcSet={ `${require('../../resources/img/icons/facet-all-protections-icon.png')} 2x` }
					alt="Fire and Water Icon"
				/> 
			);
		}

		const labelClasses = classnames({
			active: facet.checked,
			'has-icon': hasIcon,
			'double-icon': iconDouble,
			'triple-icon': iconTriple
		});

		return (
			<li>
				<input
					type="checkbox"
					id={ facetId }
					value={ facet.value }
					checked={ facet.checked }
					onChange={ e => this.handleClick(e) }
				/>
				<label
					htmlFor={ facetId }
					className={ labelClasses }
				>
					{ facetIcon }{ facet.name } &#40;{ facet.count }&#41;
				</label>
			</li>
		);
	}
};

export default Facet;


// WEBPACK FOOTER //
// ./src/pages/productSearch/Facet.js